module.exports = __webpack_public_path__ + "static/media/fake-guest-face.2d08575c.svg";